import * as jwt from 'jsonwebtoken';

export class TokenWrapper {
  public expiry: number | null;

  private token: string | null;
  private provision: () => Promise<string>;
  private _getToken: Promise<string>;

  constructor(
    provision: () => Promise<string>,
    protected timeout_ms = 10_000
  ) {
    this.provision = provision;
    this.token = null;
    this.expiry = null;
    this._getToken = null;
  }

  invalidate() {
    this.token = null;
    this.expiry = null;
  }

  getToken() {
    if (this._getToken) {
      return this._getToken;
    }
    if (this.valid()) {
      return Promise.resolve(this.token);
    }
    this.token = null;
    this._getToken = this.provisionToken()
      .then((token) => {
        const claim = jwt.decode(token, { complete: true });
        // @ts-ignore
        this.expiry = claim.payload.exp * 1000;
        this.token = token;
        return token;
      })
      .finally(() => {
        this._getToken = null;
      });
    return this._getToken;
  }

  /**
   * Sometimes in scenarios when switching networks, laptop lid is down etc... _getToken will be stuck in a pending
   * state which deadlocks websockets from reconnecting. This adds a timeout.
   */
  async provisionToken() {
    return new Promise<string>(async (resolve, reject) => {
      let timeout = setTimeout(() => {
        reject(new Error('Provision timeout'));
      }, this.timeout_ms);
      try {
        let token = await this.provision();
        resolve(token);
      } catch (ex) {
        reject(ex);
      } finally {
        clearTimeout(timeout);
      }
    });
  }

  valid() {
    return !!this.token && !!this.expiry && this.expiry > Date.now();
  }

  async getHeaders() {
    const token = await this.getToken();
    return {
      Authorization: `Bearer ${token}`
    };
  }
}
